export default "__VITE_ASSET__CE9cFttY__"